import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { AppParametersService, AppState } from '@immosky/types';
import {
  updateFilter,
  updateFilterConfig,
} from '@immosky/object-search-filter';
import { SearchSubscriptionAppParameters } from './services/search-subscription-app-parameters.service';

@Component({
  selector: 'app-search-subscription',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('parameters-id')
  parametersId = '';

  isMobileOpen = false;

  constructor(
    private store: Store<AppState>,
    private appParametersService: AppParametersService<SearchSubscriptionAppParameters>
  ) {}

  ngOnInit(): void {
    this.appParametersService.getAppParametersFromDOM(this.parametersId);
    this.setInitialFilters();
  }

  setInitialFilters() {
    const { countries } = this.appParametersService.get();

    this.store.dispatch(
      updateFilter({
        countries: countries,
      })
    );

    this.store.dispatch(updateFilterConfig());
  }

  open() {
    this.isMobileOpen = true;
  }

  close() {
    this.isMobileOpen = false;
  }
}
